const MERCHANT_CODE = '79027019';

const MOMO_STEPS = [
  'Open the MTN MoMo app, or dial *165# on your phone.',
  'Select "Pay Bill" / "Pay Merchant".',
  <>
    Enter Merchant Code <strong className="font-bold text-text">{MERCHANT_CODE}</strong>.
  </>,
  'Enter the total amount shown below and confirm the merchant name is "Chikwafu".',
  'Enter your MoMo PIN to complete payment.',
  'Send a screenshot of the confirmation to our WhatsApp with your name and order items.',
];

export function PaymentMethod({ method, onChange }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-card p-5">
      <h2 className="mb-4 text-sm font-extrabold uppercase tracking-wide text-text-muted">
        How would you like to pay?
      </h2>

      <div className="flex flex-col gap-3">
        <MethodOption
          id="momo"
          active={method === 'momo'}
          title="Pay now with MTN MoMo"
          subtitle="Pay the merchant code below, we dispatch once confirmed"
          onSelect={() => onChange('momo')}
        />
        <MethodOption
          id="delivery"
          active={method === 'delivery'}
          title="Pay on delivery"
          subtitle="Pay cash or MoMo when your order arrives"
          onSelect={() => onChange('delivery')}
        />
      </div>

      {method === 'momo' && (
        <div className="mt-5 rounded-xl border border-accent/20 bg-accent-dim p-4">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-wide text-text-muted">
              Merchant code
            </span>
            <span className="text-lg font-black tracking-wider text-accent">{MERCHANT_CODE}</span>
          </div>
          <ol className="flex flex-col gap-2">
            {MOMO_STEPS.map((step, i) => (
              <li key={i} className="flex gap-2 text-xs leading-relaxed text-text-muted">
                <span className="shrink-0 font-bold text-accent">{i + 1}.</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </div>
      )}

      {method === 'delivery' && (
        <div className="mt-5 rounded-xl border border-white/10 bg-bg3 p-4">
          <p className="text-xs leading-relaxed text-text-muted">
            Your order is delivered within{' '}
            <strong className="font-bold text-text">3 working days</strong>. Pay the rider in cash
            or MoMo when it arrives — the exact amount, including any delivery fee, is confirmed
            with you on WhatsApp before dispatch.
          </p>
        </div>
      )}

      <p className="mt-4 text-xs text-text-dim">
        All orders, regardless of payment method, are delivered within 3 working days.
      </p>
    </div>
  );
}

function MethodOption({ id, active, title, subtitle, onSelect }) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={active}
      className={`flex items-start gap-3 rounded-xl border px-4 py-3 text-left transition-colors ${
        active ? 'border-accent bg-accent-dim' : 'border-white/10 hover:border-white/20'
      }`}
    >
      <span
        className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 ${
          active ? 'border-accent' : 'border-white/20'
        }`}
      >
        {active && <span className="h-2 w-2 rounded-full bg-accent" />}
      </span>
      <span>
        <span className="block text-sm font-bold">{title}</span>
        <span className="block text-xs text-text-muted">{subtitle}</span>
      </span>
    </button>
  );
}

export { MERCHANT_CODE };
